const Request = require('./BaseRequest')
const ShopGraph = require('../graph/ShopGraph')

module.exports = class ShopRequest extends Request
{
    constructor(apiDomain)
    {
        super(apiDomain)
        this.graph = new ShopGraph(this.apiDomain)
    }

    async cart(cart, optional={})
    {
        let args = {cart: cart, ...optional}
        let { type, query} = this.graph.cartQuery([
            {
                items: [
                    {
                        product: [
                            'name', 'code', 'description', 'thumbnail',
                            {configuration: ['payment', 'installment_count', 'period', 'billing_frequency']},
                        ]
                    },
                    {
                        riders: [
                            {
                                product: [
                                    'name', 'code', 'description', 'thumbnail',
                                    {configuration: ['payment', 'installment_count', 'period', 'billing_frequency']}
                                ]
                            },
                            'quantity', 'price', 'recurring_fee', 'payable', 'recurring_payable'
                        ]
                    },
                    {
                        promo: ['name', 'code', 'config']
                    },
                    'promo_code', 'quantity', 'shipping', 'price', 'less', 'payable', 'recurring_fee', 'recurring_less', 'recurring_payable', 'misc'
                ]
            },
            {
                promo: ['name', 'code']
            },
            'total', 'cart_less', 'less', 'payable', 'currency', 'shipping',
            'promo_code', 'item_count', 'recurring_count', 'paypal_allow', 'stripe_allow', 'array', 'error'
        ])
        let data = await this.graph.request(query, args, type)
        return data
    }

    async checkout(cart, userId, payment_method, optional={})
    {
        let args = { cart: cart, userId: userId, payment_method: payment_method, ...optional }
        let { type, query } = this.graph.checkoutMutation([
            'state', 'redirect',
            {order: [
                'orderId', 'gateway', 'status', 'payable'
            ]}
        ])
        let data = await this.graph.request(query, args, type)
        return data
    }

    async change(item_id, product, optional={})
    {
        let args = { item_id: item_id, product: product, ...optional }
        let { type, query } = this.graph.changeMutation(['state', 'redirect'])
        let data = await this.graph.request(query, args, type)
        return data
    }

    swrProduct(code)
    {
        let args = {code: code}
        let { type, query} = this.graph.productQuery([
            'id', 'code', 'name', 'thumbnail', 'description',
            {configuration: ['payment', 'installment_count', 'period', 'billing_frequency']},
            { price: ['currency', 'base_price', 'recurring_fee']},
            { riders: 
                [
                    'code', 'name',
                    { price: ['currency', 'base_price', 'recurring_fee']}
                ] 
            }
        ], args)
        return  this.graph.swrRequest(query, this.swrOptions, type)
    }

    swrProducts(optional={})
    {
        let args = {...optional}
        let { type, query} = this.graph.productsQuery([
            'code', 'name', 'thumbnail', 'description',
            {configuration: ['payment', 'installment_count', 'period', 'billing_frequency']},
            { price: ['currency', 'base_price', 'recurring_fee']},
            { riders: 
                [
                    'code', 'name',
                    { price: ['currency', 'base_price', 'recurring_fee']}
                ] 
            }
        ], args)
        return  this.graph.swrRequest(query, this.swrOptions, type)
    }

    swrPrice(product, optional={})
    {
        let args = {product, ...optional}
        let { type, query} = this.graph.priceQuery(['currency', 'base_price', 'recurring_fee', 'promoPrice', 'promoFee'], args)
        return  this.graph.swrRequest(query, this.swrOptions, type)
    }

    swrSubscription(product, userId)
    {
        let args = {product: product, userId: userId}
        let { type, query} = this.graph.subscriptionQuery([
            'id',
            {product: ['name', 'code']}
        ], args)
        return  this.graph.swrRequest(query, this.swrOptions, type)
    }

    swrOrder(orderId, useSwr = true)
    {
        let args = { orderId: orderId }
        let { type, query } = this.graph.orderQuery([
            'orderId',
            'payment_date',
            'created_at',
            'status'
        ], args)
        if (useSwr) return this.graph.swrRequest(query, this.swrOptions, type)
        return this.graph.request(query, args, type)
    }
    
    swrOnetimeOrder(product, userId)
    {
        let args = {product: product, userId: userId}
        let { type, query} = this.graph.onetimeOrderQuery([
            'id',
            {product: ['name', 'code']}
        ], args)
        return  this.graph.swrRequest(query, this.swrOptions, type)
    }
}